export const normalizeSearchResult = (result) => {
    var _a, _b;
    // eslint-disable-next-line no-underscore-dangle
    if (result.__typename === 'SearchResultProject') {
        return {
            id: result.entityId,
            name: result.name,
            customerId: (_a = result.customerId) !== null && _a !== void 0 ? _a : undefined,
        };
    }
    // eslint-disable-next-line no-underscore-dangle
    if (result.__typename === 'FileSystemProject') {
        return {
            id: result.id,
            name: result.name,
            customerId: (_b = result.customerId) !== null && _b !== void 0 ? _b : undefined,
        };
    }
    return {
        id: result.id,
        name: result.name,
        customerId: undefined,
    };
};
